// @ts-nocheck

import _ from "lodash";
import { getGridFilters } from "models/dynamicGrid/selector";
import { useSelector } from "react-redux";
import StackItem from "molecules/stackItem/stackItem";
import Stack from "molecules/stack/stack";
import Label from "atoms/label/label";
import { AgGridSearchFilter } from "organisms/searchFilter/components/agGridSearchFilter";
import React from "react";

export const FilterTags = ({ tableId, gridRef }) => {
  const tableFilters = useSelector((state) => getGridFilters(state, tableId));
  const activeFilterTags = _.filter(
    tableFilters?.search,
    (searchQuery) => searchQuery.operator && !searchQuery.isLocked
  );
  
  return (
    Boolean(activeFilterTags?.length) && (
      <Stack className="mb-3 flex-cs" gutter="tiny" isGap>
        <StackItem className="applied-filters-label">
          <Label isHighlight>Applied Filters</Label>
        </StackItem>

        <StackItem>
          <Stack gutter="tiny" isWrap>
            {_.map(
              activeFilterTags,
              (searchQuery: types.TSearchQuery, index: number) => {

                return (
                  searchQuery.operator &&
                  !searchQuery.isLocked && (
                    <React.Fragment key={searchQuery.id}>
                      <StackItem>
                        <AgGridSearchFilter
                          currentQuery={searchQuery}
                          tableId={tableId}
                          updateQuery={() => {}}
                          removeQuery={() => {}}
                          isTagFilter={true}
                          onUpdateQueries={() => {
                            gridRef?.current?.api.refreshServerSide({
                              route: [],
                              purge: true,
                            });
                          }}
                          currentColumnRef={gridRef?.current?.api
                            ?.getColumns()
                            .find((d) => {
                              return (
                                d.colDef.field ===
                                searchQuery.criteria.rowIdentifier ||  d.colDef.field === searchQuery.criteria.label
                              );
                            })}
                        />
                      </StackItem>
                      {index < activeFilterTags?.length - 1 && (
                        <StackItem
                          position="center"
                          className="applied-filters-label"
                        >
                          <Label isSecondary> &nbsp; And &nbsp; </Label>
                        </StackItem>
                      )}
                    </React.Fragment>
                  )
                );
              }
            )}
          </Stack>
        </StackItem>
      </Stack>
    )
  );
};
